




























































import Vue from 'vue'
import { Component } from '@niknevis/vue-modules'
import BaseCard from '@/modules/shared/components/shared/base/BaseCard.vue'
import BaseSelect from '@/modules/shared/components/shared/kit/BaseSelect.vue'
import BaseInput from '@/modules/shared/components/shared/kit/BaseInput.vue'
import CurrencyInput from '@/modules/shared/components/shared/form/CurrencyInput.vue'
import BaseCart from '@/modules/common/cart/components/panel/BaseCart.vue'
import { StartPaymentResource } from '@/modules/transaction/models/payment.model'
import BaseButton from '@/modules/shared/components/shared/kit/BaseButton.vue'
import { Prop } from 'vue-property-decorator'
import { OwnBankInfoResourceModel } from '@/modules/bank-account/models/bank-account-resource.model'
import { Data } from '@/modules/shared/models/data'
import PanelLayout from '@/modules/common/layout/components/panel/PanelLayout.vue'
import FinalPayment from '@/modules/transaction/components/shared/payment/FinalPayment.vue'
import { WalletGetPaymentLinkUseCase } from '@/modules/wallet/use-cases/panel/wallet-get-payment-link.use-case'
import AlertNotification from '@/modules/notification/components/panel/AlertNotification.vue'
import { localStringToNumber } from '@/modules/shared/helpers/utils/utils'

@Component({
  layout: PanelLayout,
  layoutProps: {
    page_header: 'شارژ حساب کاربری',
    page_sub_header: 'در این بخش میتوانید موجودی کیف پول خود را افزایش دهید.'
  },
  metaInfo: {
    title: 'شارژ حساب کاربری'
  },
  components: {
    AlertNotification,
    FinalPayment,
    BaseButton,
    BaseCart,
    CurrencyInput,
    BaseInput,
    BaseSelect,
    BaseCard
  }
})
export default class WalletPageIndex extends Vue {
  constructor(
    private readonly useCase: WalletGetPaymentLinkUseCase
  ) {
    super()
  }

  @Prop() wallet!: Data<OwnBankInfoResourceModel>
  localStringToNumber: Function = localStringToNumber

  select = null
  alert = true

  charge = 500000
  minimumCharge = 500000
  chargeOptions = [
    // {
    //   label: '100،000 تومان',
    //   value: 100000
    // },
    // {
    //   label: '200،000 تومان',
    //   value: 200000
    // },
    // {
    //   label: '300،000 تومان',
    //   value: 300000
    // },
    // {
    //   label: '400،000 تومان',
    //   value: 400000
    // },
    {
      label: '500،000 تومان',
      value: 500000
    },
    {
      label: '1،000،000 تومان',
      value: 1000000
    },
    {
      label: '2،000،000 تومان',
      value: 2000000
    }
  ]

  setCharges() {
    this.charge = this.select.value
  }

  removeSelect() {
    this.select = null
  }

  get payInfo() {
    return [
      {
        class: 'font-weight-bold',
        value: (this.charge) ? this.charge.toLocaleString() : 0,
        unit: 'تومان',
        column: 'قابل پرداخت'
      }
    ].filter(Boolean)
  }

  async getPaymentResource(data): Promise<void | StartPaymentResource> {
    return this.useCase.execute(
      { ...data, payable: this.charge }
    ).then(res => res)
  }
}
